module.exports = __webpack_public_path__ + "img/v2_leaf_left_big.28f706bb.png";